const gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 });
const int = new Intl.NumberFormat('en-GB');

export const money = (v: number | null | undefined): string => (v === null || v === undefined ? '—' : gbp.format(v));

export const moneyRange = (min: number | null | undefined, max: number | null | undefined): string => {
  if (min === null || min === undefined) return '—';
  if (max === null || max === undefined || Math.abs(max - min) < 0.005) return gbp.format(min);
  return `${gbp.format(min)} – ${gbp.format(max)}`;
};

export const pct = (v: number | null | undefined, digits = 0): string =>
  v === null || v === undefined ? '—' : `${v.toFixed(digits)}%`;

export const count = (v: number): string => int.format(v);

export const sellPrice = (cost: number | null, margin: number | null, discount: number | null = null): number | null => {
  if (cost === null || margin === null) return null;
  const base = cost * (1 + margin / 100);
  const discounted = discount !== null ? base * (1 - discount / 100) : base;
  return Math.round(discounted * 100) / 100;
};

// "51 51 51" → "rgb(51 51 51)"; falls back to a neutral swatch.
export const swatchColour = (rgb: string | null | undefined): string => {
  if (!rgb) return '#D1D5DB';
  const parts = rgb.trim().split(/\s+/).map(Number);
  if (parts.length !== 3 || parts.some((n) => !Number.isFinite(n))) return '#D1D5DB';
  return `rgb(${parts.join(' ')})`;
};

export const relativeTime = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.round(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};

export const cleanText = (s: string | null | undefined): string => (s ?? '').replace(/�/g, '').trim();

// Feed size ranges arrive as "Sto3XL", "XStoXL", "5.5/8to12/14.5", "XS to 4XL".
export const sizeRangeLabel = (s: string | null | undefined): string => {
  const v = cleanText(s);
  if (!v) return '';
  const m = v.match(/^(.+?)\s*to\s*(.+)$/i);
  if (!m) return v;
  return `${m[1].trim()} – ${m[2].trim()}`;
};
